import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { ReactComponent as DrawerClose } from 'common/assets/images/drawer-close.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import { APP_THEME } from 'common/constants';
import {
	BLUE_THEME_TEXT,
	ORANGE_THEME_TEXT,
} from 'common/constants/TextContent';
import localStorageWrapper from 'common/loginUtils/local-storage-wrapper';
import { setAppThemeDrawerState } from 'common/store/reducer/commonReducer';

import styles from './Theme.module.scss';

const { primaryBlue, primaryOrange } = styles;

/**
 * Represents the theme component.
 */
const Theme = () => {
	const dispatch = useDispatch();

	/**
	 * Closes the app theme drawer.
	 */
	const handleDrawerClose = useCallback(() => {
		dispatch(setAppThemeDrawerState(false));
	}, [setAppThemeDrawerState]);

	/**
	 * Handles the change of the theme.
	 *
	 * @param theme - The new theme to apply.
	 */
	const onChangeTheme = (theme: string) => {
		const rootElement = document.querySelector('body');
		rootElement?.setAttribute('app-theme', theme);
		localStorageWrapper.setStorageItem('appTheme', theme);
		document.documentElement.style.setProperty('--primary-blue', primaryBlue);
		document.documentElement.style.setProperty(
			'--primary-orange',
			primaryOrange,
		);
		handleDrawerClose();
	};

	return (
		<Box
			className={styles['theme-container']}
			role="presentation"
			data-testid="theme-container"
		>
			<div className={styles['theme-top-div']}>
				<div
					className={styles['theme-text-background']}
					data-testid="theme-top-div"
				>
					<Stack
						direction="row"
						justifyContent="flex-end"
						spacing={2}
						data-testid="close-button-stack"
					>
						<IconButton
							size="large"
							onClick={handleDrawerClose}
							data-testid="close-groups-btn"
							className={styles['close-icon']}
							disableRipple
						>
							<DrawerClose fill={styles.drawerCloseIconColor} />
						</IconButton>
					</Stack>
				</div>
				<Box className={styles['text-box']}>
					<Stack direction="row" justifyContent="space-between">
						<Typography className={styles['source-heading']}>
							Change Colour Preference
						</Typography>
					</Stack>
				</Box>
			</div>
			<div className={styles['theme-content']}>
				<Grid container>
					<Grid item className={styles['theme-grid-item']}>
						<ButtonComp
							btnType="primary"
							clickHandler={() => onChangeTheme(APP_THEME.ORANGE)}
							compClass={styles['theme-orange']}
							disableRipple
							data-testid="theme-orange"
						>
							{ORANGE_THEME_TEXT}
						</ButtonComp>
					</Grid>
					<Grid item className={styles['theme-grid-item']}>
						<ButtonComp
							btnType="primary"
							clickHandler={() => onChangeTheme(APP_THEME.BLUE)}
							compClass={styles['theme-blue']}
							disableRipple
							data-testid="theme-blue"
						>
							{BLUE_THEME_TEXT}
						</ButtonComp>
					</Grid>
				</Grid>
			</div>
		</Box>
	);
};

export default Theme;
